var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUpload = function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "upload_svg2__a",
    x1: 39.57,
    x2: 149.68,
    y1: 182.23,
    y2: 12.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#upload_svg2__a",
    id: "upload_svg2__b",
    x1: 36.32,
    x2: 146.44,
    y1: 180.12,
    y2: 10.71
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#upload_svg2__a",
    id: "upload_svg2__c",
    x1: 44.22,
    x2: 154.33,
    y1: 185.25,
    y2: 15.84
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#upload_svg2__a",
    id: "upload_svg2__d",
    x1: 72.04,
    x2: 182.15,
    y1: 203.33,
    y2: 33.92
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#upload_svg2__a",
    id: "upload_svg2__e",
    x1: 42.56,
    x2: 152.67,
    y1: 184.17,
    y2: 14.76
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#upload_svg2__a",
    id: "upload_svg2__f",
    x1: 76.66,
    x2: 186.78,
    y1: 206.34,
    y2: 36.93
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#upload_svg2__a",
    id: "upload_svg2__g",
    x1: 78.24,
    x2: 188.36,
    y1: 207.37,
    y2: 37.95
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m177.3 46.17-14.96-14.96V8.89c0-4.9-3.99-8.89-8.89-8.89H30.62c-4.84 0-8.78 3.94-8.78 8.78v147.28c0 4.84 3.94 8.78 8.78 8.78h4.97v4.89c0 4.84 3.94 8.78 8.78 8.78h19.04c1.62 0 2.93-1.31 2.93-2.93s-1.31-2.93-2.93-2.93H44.37c-1.61 0-2.92-1.31-2.92-2.92V51.94c0-1.62-1.31-2.93-2.93-2.93s-2.93 1.31-2.93 2.93v107.04h-4.97c-1.61 0-2.92-1.31-2.92-2.92V8.78c0-1.61 1.31-2.92 2.92-2.92h122.83c1.67 0 3.03 1.36 3.03 3.03v16.46l-10.82-10.82c-.55-.55-1.29-.86-2.07-.86H44.36c-4.84 0-8.78 3.94-8.78 8.78V38.3c0 1.62 1.31 2.93 2.93 2.93s2.93-1.31 2.93-2.93V22.45c0-1.61 1.31-2.92 2.92-2.92h96.3v28.7c0 1.62 1.31 2.93 2.93 2.93h28.71v118.56c0 1.61-1.31 2.92-2.92 2.92h-18.82c-1.62 0-2.93 1.31-2.93 2.93s1.31 2.93 2.93 2.93h18.82c4.84 0 8.78-3.94 8.78-8.78V48.24c0-.78-.31-1.52-.86-2.07m-30.78-22.5 10.82 10.82 10.82 10.82h-21.64z",
    style: {
      fill: "url(#upload_svg2__a)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.99 68.54H71.9c-1.62 0-2.93 1.31-2.93 2.93s1.31 2.93 2.93 2.93h70.09c1.62 0 2.93-1.31 2.93-2.93s-1.31-2.93-2.93-2.93",
    style: {
      strokeWidth: 0,
      fill: "url(#upload_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.99 85.82H71.9c-1.62 0-2.93 1.31-2.93 2.93s1.31 2.93 2.93 2.93h70.09c1.62 0 2.93-1.31 2.93-2.93s-1.31-2.93-2.93-2.93",
    style: {
      strokeWidth: 0,
      fill: "url(#upload_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.99 103.44h-13.85c-1.62 0-2.93 1.31-2.93 2.93s1.31 2.93 2.93 2.93h13.85c1.62 0 2.93-1.31 2.93-2.93s-1.31-2.93-2.93-2.93",
    style: {
      strokeWidth: 0,
      fill: "url(#upload_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.35 109.3c1.62 0 2.93-1.31 2.93-2.93s-1.31-2.93-2.93-2.93H71.9c-1.62 0-2.93 1.31-2.93 2.93s1.31 2.93 2.93 2.93z",
    style: {
      strokeWidth: 0,
      fill: "url(#upload_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.02 143.44c-1.14-1.14-3-1.14-4.14 0l-12.81 12.81c-1.14 1.14-1.14 3 0 4.14s3 1.14 4.14 0l7.81-7.81v28.32c0 1.62 1.31 2.93 2.93 2.93s2.93-1.31 2.93-2.93v-28.32l7.81 7.81a2.924 2.924 0 0 0 4.14 0c1.14-1.14 1.14-3 0-4.14z",
    style: {
      strokeWidth: 0,
      fill: "url(#upload_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.95 126.41c-20.29 0-36.8 16.51-36.8 36.79s16.51 36.79 36.8 36.79 36.8-16.51 36.8-36.79-16.51-36.79-36.8-36.79m0 67.73c-17.06 0-30.94-13.88-30.94-30.94s13.88-30.94 30.94-30.94 30.94 13.88 30.94 30.94-13.88 30.94-30.94 30.94",
    style: {
      strokeWidth: 0,
      fill: "url(#upload_svg2__g)"
    }
  }));
};
export default SvgUpload;